
import { CityPageTemplate } from '@/components/seo/CityPageTemplate';
import { Heart, Building2, GraduationCap } from 'lucide-react';

const PhiladelphiaPage = () => {
  return (
    <CityPageTemplate
      city="Philadelphia"
      state="Pennsylvania"
      stateAbbr="PA"
      population="1.6 million+"
      majorIndustries={["healthcare", "education", "manufacturing", "financial services", "biotechnology"]}
      businessChallenges={[
        "Healthcare industry regulatory compliance",
        "University partnership and student employment",
        "Aging infrastructure and operational challenges",
        "Pennsylvania tax complexity and compliance",
        "Manufacturing workforce development needs"
      ]}
      peoSolutions={[
        "Healthcare industry specialized compliance support",
        "Student employment and internship program management",
        "Pennsylvania tax and regulatory compliance expertise",
        "Manufacturing workforce development programs",
        "Multi-industry risk management solutions"
      ]}
      localBusinessTypes={[
        { name: "Healthcare", description: "Hospitals, medical centers, pharmaceuticals" },
        { name: "Education", description: "Universities, colleges, research institutions" },
        { name: "Manufacturing", description: "Chemicals, textiles, food processing" },
        { name: "Biotechnology", description: "Research, pharmaceuticals, medical devices" }
      ]}
      metaDescription="Find the best PEOs in Philadelphia with The PEO App. Compare quotes from top Philadelphia Professional Employer Organizations offering specialized HR solutions for healthcare, education, and biotechnology industries."
      keyFeatures={[
        {
          icon: Heart,
          title: "Healthcare Excellence",
          description: "Comprehensive HR solutions for Philadelphia's world-class healthcare sector with regulatory compliance and specialized benefits."
        },
        {
          icon: GraduationCap,
          title: "Education Sector Support",
          description: "Expert HR services for Philadelphia's educational institutions including student employment and research facility management."
        },
        {
          icon: Building2,
          title: "Biotech Industry Focus",
          description: "Specialized HR solutions for Philadelphia's biotechnology corridor with research compliance and IP protection support."
        }
      ]}
    />
  );
};

export default PhiladelphiaPage;
